<template>
    <div class="card p-0 m-0" :class="{'active': stepState.active, 'completed': stepState.completed}">
        <div class="card-header" @click="$emit('headerclick')">
            <div class="lighter text-white p-0">
                <slot name="title"></slot>
            </div>
        </div>
        <div class="card-body" v-show="stepState.active || stepState.completed">
            <!-- commented out b/c doesn't work with IE11. -->
            <!-- <expand-transition> -->
                <div v-if="stepState.active" >
                    <slot name="content"></slot>
                    <div class="report-back-next">
                        <button type="button" class="btn btn-orange-blue btn-sm" @click="$emit('previous')" v-if="previousButton">Back</button>
                        <button type="button" class="btn btn-orange-blue btn-sm" @click="$emit('next')" v-if="nextButton">Next</button>
                    </div>
                </div>
            <!-- </expand-transition> -->
            <strong  v-show="showSummary" class="text-medium-blue">
                <slot name="summary">
                </slot>
            </strong>
        </div>
    </div>
</template>

<script>
    import ExpandTransition from '../ExpandTransition'

    export default {
        components: {
            ExpandTransition
        },
        props: {
            previousButton: {
                type: Boolean,
                default: true
            },
            nextButton: {
                type: Boolean,
                default: true
            },
            stepState: {
                required: true,
                type: Object
            }
        },
        data() {
            return {
            }
        },
        computed: {
            headerClass: function() {
                if (this.stepState && this.stepState.active) {
                    return 'bg-primary'
                } 
                if (this.stepState && this.stepState.completed) {
                    return 'bg-navy'
                }
                return '';
            },
            // cardClass: function() {
            //     if (this.stepState && this.stepState.active) {
            //         return 'selected'
            //     } 
            //     if (this.stepState && this.stepState.completed) {
            //         return 'completed'
            //     }
            //     return '';
            // },
            showSummary: function () {
                return !this.stepState.active && this.stepState.completed
            }
        }
}
</script>